import { BlockType, ResultBlock, SurveyResultBlock } from './types';
import { BlockId } from '@/administration/pages/Course/store/types';
import { Course } from '@/administration/pages/Course/store/course/types';
import { SurveyVariant } from '@/features/course/learner/types/survey';
import { PracticalAssessment } from '@/features/course/learner/types/practicalAssessment';

export const createResultBlock = (course?: Course | PracticalAssessment): ResultBlock => ({
  id: `block-l-return` as BlockId,
  type: BlockType.RESULT,
  level: course?.level || '',
  effortHours: course?.effortHours || undefined,
  effortMinutes: course?.effortMinutes || undefined,
});

export const createSurveyResultBlock = (surveyVariant: SurveyVariant): SurveyResultBlock => ({
  id: `block-l-return` as BlockId,
  type: BlockType.SURVEY_RESULT,
  variant: surveyVariant,
});
